export const USER_INFO = 'USER_INFO'
export const MENU = 'MENU'
export const PERM = 'PERM'
export const ADER_SETTING = 'ADER_SETTING'
export const AD_SETTING = 'AD_SETTING'
export const AFF_SETTING = 'AFF_SETTING'
export const CHANNEL_SETTING = 'CHANNEL_SETTING'
export const FINANCE_SETTING = 'FINANCE_SETTING'
export const COUNTRIES = 'COUNTRIES'
export const CARRIERS = 'CARRIERS'
export const ALL_CARRIERS = 'ALL_CARRIERS'
export const TIMEZONE = 'TIMEZONE'
export const TIMEZONEV1 = 'TIMEZONEV1'
export const OFFER_SETTING = 'OFFER_SETTING'
export const ROLE = 'ROLE'
export const INCLUDES = 'INCLUDES'
export const OS_SETTING = 'OS_SETTING'
export const CODE_REASON = 'CODE_REASON'
export const CRITICISM_REASON = 'CRITICISM_REASON'
export const RECOMMEND_TYPE = 'RECOMMEND_TYPE'
export const FORM_ORIGIN = 'FORM_ORIGIN'
export const ASO_ADER_SETTING = 'ASO_ADER_SETTING'
